import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('card-layout'),
    children: [
        getRoute('/oops', 'oops', 'oops', { title: 'Error' }),
    ],
};